import { User } from "@checkout-core/interfaces/User";
import { AnalyticsConfig, getAnalyticsConfigParams as getConfigParams } from "@swiggy-private/analytics";
import { Option } from "@swiggy-private/js-fp";
import { isEmpty } from "@swiggy-private/js-utils";
import { GlobalHeaderState } from "@checkout-core/utils/Headers";

export const getAnalyticsConfigParams = (user: Option<User>, apiHost: string): AnalyticsConfig | undefined => {
    let isGuestUser = false;

    if (user.isNone()) {
        isGuestUser = true;
    }

    const headers = GlobalHeaderState.getHeaders();
    const userDetails = isGuestUser ? { userId: "--" } : user.unwrap();

    const config = userDetails && getConfigParams(headers, apiHost);
    if (!config) return config;

    // Override application_name from x-channel when not set by client
    const xChannel = headers?.["x-channel"] ?? "";

    // x-cart-type is used to identify the cart type (regular, mro, aip, etc.)
    const xCartType = headers?.["x-cart-type"] ?? "";
    const extraParams: Record<string, string> = {};

    if (!isEmpty(xChannel) && isEmpty(config.applicationName)) {
        return { ...config, applicationName: xChannel };
    }

    if (!isEmpty(xCartType)) {
        extraParams["x-cart-type"] = xCartType;
    }

    return { ...config, extraParams };
};
